import { fromBool } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import * as React from 'react';
import ChatMessageStore from '../../ChatMessageStore';
import * as style from '../Conference/style.module.css';
import Button from '../Form/Button';
import ChatEditor from '../TeamProfile/TeamChat/StyleControls/ChatEditor';
import ChatEditorProvider from '../TeamProfile/TeamChat/StyleControls/ChatEditorProvider';

interface Props {
  store: ChatMessageStore;
}

const ChatMessageForm: React.FC<Props> = ({ store }) => {
  const submitChatMessage = () =>
    store.message.andThen((m) => fromBool(m.text.length > 0, m)).do(store.updating);

  const submit = (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    submitChatMessage();
  };

  return (
    <ChatEditorProvider>
      <form className={style.form}>
        <div className={style.textarea}>
          <ChatEditor
            store={store}
            submitChatMessage={submitChatMessage}
            placeholder="Send a message to the group..."
            contentClassName={style.editorContent}
          />
        </div>
        <Button
          type="submit"
          className={style.submitButton}
          value="Send"
          onClick={submit}
          disabled={store.state.kind === 'updating'}
        />
      </form>
    </ChatEditorProvider>
  );
};
export default observer(ChatMessageForm);
